import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

export type DeleteDmsDealerPayload = {
  dealer_id: number;
  dms_id: number;
};

export const useDeleteDmsDealerMutation = () =>
  useTypedMutation<DeleteDmsDealerPayload, void>({
    mutationFn: async payload => (await ApiInstance.post(`/config/dealer/delete`, payload, ENV.dmsv3BaseURL)).data,
    onSuccess: payload => {
      const dealers = typedQueryClient.getQueryData(DMSv3SettingsDashboardQueryKeys.dealers);
      if (!dealers) return;

      const dealerIdx = dealers.findIndex(dealer => dealer.dealer_id === payload.dealer_id && dealer.dms_id === payload.dms_id);
      if (dealerIdx === -1) return;

      typedQueryClient.setQueryData(DMSv3SettingsDashboardQueryKeys.dealers, dealers.toSpliced(dealerIdx, 1));
    }
  });
